import { render } from "./AvatarLabel.vue?vue&type=template&id=3e0081c4"
import script from "./AvatarLabel.vue?vue&type=script&lang=js"
export * from "./AvatarLabel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__